module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('h2', {
    staticClass: "truncate"
  }, [_vm._v("Xero Status")]), _vm._v(" "), (!_vm.link) ? [_c('br'), _vm._v(" "), _c('h3', [_vm._v("\n          Linked to Account\n        ")]), _vm._v(" "), (_vm.data.tenant_type) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 strong"
  }, [_vm._v("Tenant Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.data.tenant_type))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 strong"
  }, [_vm._v("Tenant Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.data.tenant_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 strong"
  }, [_vm._v("Tenant Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.data.tenant_name))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("\n          API Usage limits\n        ")]), _vm._v(" "), (_vm.data.tenant_type) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 strong"
  }, [_vm._v("Day Limit Remaining")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.data.day_limit_remaining))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 strong"
  }, [_vm._v("Minute Limit Remaining")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.data.min_limit_remaining))])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.link) ? _c('div', [(_vm.tokenRefreshFailed) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n          We have been unable to refresh your Xero Access Token and therefore your Xero link is currently "), _c('strong', [_vm._v("disabled")]), _vm._v(". In order to re-activate your link please \"Disconnect\" the connected Application here: "), _c('a', {
    attrs: {
      "href": "https://identity.xero.com/account/apps/",
      "target": "blank"
    }
  }, [_vm._v("Connected Applications")]), _vm._v(" then re-link Xero below.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.displayRelink) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n          Your application is not currently linked to Xero, please hit the button below to link.\n        ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v("Link Xero")])]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-d61dc7c0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/system/Xero.vue
// module id = 1080
// module chunks = 0